
import { useNavigate } from 'react-router-dom'; 
const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <h2 style={styles.message}>Oops! Page Not Found</h2>
      <p style={styles.description}>
        Sorry, the page you are looking for does not exist or has been moved.
      </p>
      <button style={styles.button} onClick={() => navigate('/')}>
        Go Back Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    background: 'linear-gradient(135deg,rgb(255, 12, 12),rgb(255, 4, 88))',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    textAlign: 'center',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  code: {
    fontSize: '10rem',
    margin: 0,
    fontWeight: 'bold',
    letterSpacing: '10px',
  },
  message: {
    fontSize: '2.5rem',
    margin: '20px 0 10px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '400px',
    marginBottom: '30px',
    opacity: 0.9,
  },
  button: {
    backgroundColor: '#ff6f61',
    border: 'none',
    borderRadius: '30px',
    color: 'white',
    padding: '15px 40px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(255,111,97,0.4)',
    transition: 'background-color 0.3s ease',
  },
};

export default ErrorPage;
